import Footer from "../../../../components/shared/Footer";
import SystemSettingsCard from "../../../../components/shared/SystemSettingsCard";

export default function QueueSettings(): JSX.Element {
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title"> Queue Settings </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Queue Settings
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <SystemSettingsCard />
            </div>
            <Footer />
        </div>
    );
}
